import { render, staticRenderFns } from "./Restoration3.vue?vue&type=template&id=08f6a10e&scoped=true"
import script from "./Restoration3.vue?vue&type=script&lang=js"
export * from "./Restoration3.vue?vue&type=script&lang=js"
import style0 from "./Restoration3.vue?vue&type=style&index=0&id=08f6a10e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6a10e",
  null
  
)

export default component.exports